import { render, staticRenderFns } from "./ImageVerificationCode.vue?vue&type=template&id=7f9128ce&scoped=true&"
import script from "./ImageVerificationCode.vue?vue&type=script&lang=ts&"
export * from "./ImageVerificationCode.vue?vue&type=script&lang=ts&"
import style0 from "./ImageVerificationCode.vue?vue&type=style&index=0&id=7f9128ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9128ce",
  null
  
)

export default component.exports